import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, ViewContainerRef, Component, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, Input, NgModule } from '@angular/core';
import { promisify } from '@js-dot/core';
import { Observable } from 'rxjs';
import { observify } from '@js-dot/rx';
import { addSpace, closeAnimate$, removeSpace$ } from '@js-dot/ui/animate';
import * as i1 from '@ng-dot/ux/color';
import { DotColorDirective } from '@ng-dot/ux/color';
import { FlashComponentBase } from '@ng-dot/ux/flash';
import * as i2 from '@ng-dot/ui/ci24';
import { DotCi24Module } from '@ng-dot/ui/ci24';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@ng-dot/ui/icon';
import { DotIconModule } from '@ng-dot/ui/icon';
import * as i5 from '@ng-dot/core';
import { DotNonKrPipe, DotUrlToAnchorPipe, DotObservifyPipe } from '@ng-dot/core';
import * as i2$1 from '@ng-dot/ux/dock';
import { DotFrameModule } from '@ng-dot/ui/frame';
import { DotTransDirective } from '@ng-dot/ui/trans';
import { DotUpDirective } from '@ng-dot/ux/up';
const _c0 = ["marker"];
function DotToastPoolComponent_ng_template_0_Template(rf, ctx) {}
function DotToastComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
    i0.ɵɵpipe(1, "icon");
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx), i0.ɵɵsanitizeHtml);
  }
}
function DotToastComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, DotToastComponent_Conditional_0_Conditional_1_Template, 2, 3, "span", 1);
    i0.ɵɵelement(2, "p", 2);
    i0.ɵɵpipe(3, "observify");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "urlToAnchor");
    i0.ɵɵelementStart(6, "div", 3)(7, "button", 4);
    i0.ɵɵlistener("click", function DotToastComponent_Conditional_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirm());
    });
    i0.ɵɵelement(8, "dot-ci24", 5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_1_0 = ctx_r1.toast.icon) ? 1 : -1, tmp_1_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(5, 7, i0.ɵɵpipeBind1(4, 5, i0.ɵɵpipeBind1(3, 3, ctx_r1.toast.body))), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("innerHTML", ctx_r1.closeText, i0.ɵɵsanitizeHtml);
  }
}
const DOT_TOAST_CONFIGURE = new InjectionToken('#ng-dot/notify/toast/configure');
class DotToastStoreService {
  configure;
  constructor(configure) {
    this.configure = {
      position: 'bottom-center',
      closeText: 'Confirm',
      defaultIcons: {},
      ...(configure || {})
    };
  }
  static ɵfac = function DotToastStoreService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToastStoreService)(i0.ɵɵinject(DOT_TOAST_CONFIGURE, 8));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotToastStoreService,
    factory: DotToastStoreService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToastStoreService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [DOT_TOAST_CONFIGURE]
    }]
  }], null);
})();
class DotToastPoolComponent {
  viewContainerRef;
  static ɵfac = function DotToastPoolComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToastPoolComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotToastPoolComponent,
    selectors: [["dot-toast-pool"]],
    viewQuery: function DotToastPoolComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
      }
    },
    hostAttrs: [1, "dot-toast-pool"],
    standalone: false,
    decls: 2,
    vars: 0,
    consts: [["marker", ""]],
    template: function DotToastPoolComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DotToastPoolComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToastPoolComponent, [{
    type: Component,
    args: [{
      selector: 'dot-toast-pool',
      template: `
		<ng-template #marker></ng-template>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-toast-pool'
      },
      standalone: false
    }]
  }], null, {
    viewContainerRef: [{
      type: ViewChild,
      args: ['marker', {
        static: true,
        read: ViewContainerRef
      }]
    }]
  });
})();
class DotToastComponent extends FlashComponentBase {
  operator;
  toast;
  closeText;
  flashOnInit() {
    super.flashOnInit();
    if (this.display) {
      addSpace(this._node);
    }
  }
  _flashClose() {
    this.confirm();
  }
  confirm() {
    super._flashClose();
    if (this.operator) {
      this.operator.confirmed(this);
    }
    // Fixed - angular has delay with routing
    // this._node.style.display = 'none';
    const {
      _node
    } = this;
    closeAnimate$(_node).then(() => {
      return removeSpace$(_node);
    }).then(() => {
      this.componentRef.destroy();
    });
  }
  observify = observify;
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotToastComponent_BaseFactory;
    return function DotToastComponent_Factory(__ngFactoryType__) {
      return (ɵDotToastComponent_BaseFactory || (ɵDotToastComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotToastComponent)))(__ngFactoryType__ || DotToastComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotToastComponent,
    selectors: [["dot-toast"]],
    hostAttrs: [1, "dot-toast"],
    hostVars: 1,
    hostBindings: function DotToastComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵhostProperty("hidden", !ctx.display);
      }
    },
    inputs: {
      operator: "operator",
      toast: "toast",
      closeText: "closeText"
    },
    standalone: false,
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: i1.DotColorDirective,
      inputs: ["color", "color"]
    }]), i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 1,
    consts: [[1, "dot-toast-area"], [1, "dot-toast-icon", 3, "innerHTML"], [1, "dot-toast-text", 3, "innerHTML"], [1, "dot-toast-buttons"], [1, "dot-toast-link", 3, "click"], ["type", "x", 3, "innerHTML"]],
    template: function DotToastComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DotToastComponent_Conditional_0_Template, 9, 9, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.display ? 0 : -1);
      }
    },
    dependencies: [i2.DotCi24Component, i3.AsyncPipe, i4.DotIconPipe, i5.DotUrlToAnchorPipe, i5.DotObservifyPipe],
    styles: [":root{--toast-min-width: 320px;--toast-max-width: 460px;--toast-back: #000;--toast-text: #fff;--toast-react-back: var(--toast-back);--toast-react-text: var(--toast-text);--toast-radius: 3em;--toast-pool-pad: 10px;--toast-pad: 8px 16px;--toast-animate: .48s;--toast-z-index: 9999;--toast-back-blur: 16px;--toast-back-blur-size: 24px}.dot-toast{min-width:var(--toast-min-width);padding:var(--toast-pool-pad);z-index:var(--toast-z-index);display:block;background-color:var(--toast-back, var(--b10));color:var(--toast-text, var(--t));border-radius:var(--toast-radius);width:100%;max-width:var(--toast-max-width);overflow:hidden;transition:.24s transform}.dot-toast-pool:empty{display:none}.dot-toast-pool.dot_top-center .dot-toast,.dot-toast-pool.dot_bottom-center .dot-toast{margin-left:auto;margin-right:auto}.dot-toast-pool.dot_top-right .dot-toast,.dot-toast-pool.dot_bottom-right .dot-toast{margin-left:auto;transform-origin:right}.dot-toast-pool:before{--_position: calc(var(--toast-back-blur-size) * -1);content:\"\";display:block;position:absolute;left:var(--_position);right:var(--_position);bottom:var(--_position);top:var(--_position);z-index:-1;transition:backdrop-filter .24s;backdrop-filter:blur(var(--toast-back-blur));-webkit-mask-image:radial-gradient(ellipse at center,black 50%,transparent 70%,transparent)}.dot-toast:not(:last-child){margin-bottom:10px}.dot-toast:hover{background-color:var(--toast-react-back);transform:scale(1.05)}.dot-toast:hover .dot-toast-text{white-space:normal}.dot-toast-area{display:flex;align-items:center;padding:var(--toast-pad);letter-spacing:0}.dot-toast-icon{margin-left:-4px;margin-right:10px}.dot-toast-text{flex-grow:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dot-toast-buttons{margin-left:20px}.dot-toast button{cursor:pointer;background-color:transparent;color:currentColor;min-height:36px;padding:6px 0;border:none}.dot-toast._close{animation:q4CubE5WCFp997JzDcZ4XvDWyaXmMkxv .24s}@keyframes q4CubE5WCFp997JzDcZ4XvDWyaXmMkxv{to{opacity:0}}.dot-toast{animation:sSlJxXIuWQbQ7fUO8T9H0xOwk30WGpbu var(--toast-animate)}@keyframes sSlJxXIuWQbQ7fUO8T9H0xOwk30WGpbu{0%{width:48px;transform:scale(0)}50%{width:48px;transform:scale(1)}}.dot-toast-text,.dot-toast-buttons{animation:sQpiD3FtOHm94cL8vwSrE4Bn4LxtkAgH var(--toast-animate)}@keyframes sQpiD3FtOHm94cL8vwSrE4Bn4LxtkAgH{0%,50%{opacity:0}}.dot-toast._main{--toast-back: var(--m-88);--toast-react-back: var(--m-72);--toast-text: var(--m88)}.dot-toast._point{--toast-back: var(--p-88);--toast-react-back: var(--p-72);--toast-text: vaR(--p88)}.dot-toast._warn{--toast-back: var(--w-88);--toast-react-back: var(--w-72);--toast-text: vaR(--w88)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToastComponent, [{
    type: Component,
    args: [{
      selector: 'dot-toast',
      template: `
		@if (display) {
			<div class="dot-toast-area">
				@if (toast.icon; as icon) {
					<span class="dot-toast-icon" [innerHTML]="icon | icon"></span>
				}
				<p class="dot-toast-text" [innerHTML]="toast.body | observify | async | urlToAnchor"></p>
				<div class="dot-toast-buttons">
					<button class="dot-toast-link" (click)="confirm()">
						<dot-ci24 type="x" [innerHTML]="closeText"></dot-ci24>
					</button>
				</div>
			</div>
		}
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[hidden]': '!display',
        class: 'dot-toast'
      },
      hostDirectives: [{
        directive: DotColorDirective,
        inputs: ['color']
      }],
      standalone: false,
      styles: [":root{--toast-min-width: 320px;--toast-max-width: 460px;--toast-back: #000;--toast-text: #fff;--toast-react-back: var(--toast-back);--toast-react-text: var(--toast-text);--toast-radius: 3em;--toast-pool-pad: 10px;--toast-pad: 8px 16px;--toast-animate: .48s;--toast-z-index: 9999;--toast-back-blur: 16px;--toast-back-blur-size: 24px}.dot-toast{min-width:var(--toast-min-width);padding:var(--toast-pool-pad);z-index:var(--toast-z-index);display:block;background-color:var(--toast-back, var(--b10));color:var(--toast-text, var(--t));border-radius:var(--toast-radius);width:100%;max-width:var(--toast-max-width);overflow:hidden;transition:.24s transform}.dot-toast-pool:empty{display:none}.dot-toast-pool.dot_top-center .dot-toast,.dot-toast-pool.dot_bottom-center .dot-toast{margin-left:auto;margin-right:auto}.dot-toast-pool.dot_top-right .dot-toast,.dot-toast-pool.dot_bottom-right .dot-toast{margin-left:auto;transform-origin:right}.dot-toast-pool:before{--_position: calc(var(--toast-back-blur-size) * -1);content:\"\";display:block;position:absolute;left:var(--_position);right:var(--_position);bottom:var(--_position);top:var(--_position);z-index:-1;transition:backdrop-filter .24s;backdrop-filter:blur(var(--toast-back-blur));-webkit-mask-image:radial-gradient(ellipse at center,black 50%,transparent 70%,transparent)}.dot-toast:not(:last-child){margin-bottom:10px}.dot-toast:hover{background-color:var(--toast-react-back);transform:scale(1.05)}.dot-toast:hover .dot-toast-text{white-space:normal}.dot-toast-area{display:flex;align-items:center;padding:var(--toast-pad);letter-spacing:0}.dot-toast-icon{margin-left:-4px;margin-right:10px}.dot-toast-text{flex-grow:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dot-toast-buttons{margin-left:20px}.dot-toast button{cursor:pointer;background-color:transparent;color:currentColor;min-height:36px;padding:6px 0;border:none}.dot-toast._close{animation:q4CubE5WCFp997JzDcZ4XvDWyaXmMkxv .24s}@keyframes q4CubE5WCFp997JzDcZ4XvDWyaXmMkxv{to{opacity:0}}.dot-toast{animation:sSlJxXIuWQbQ7fUO8T9H0xOwk30WGpbu var(--toast-animate)}@keyframes sSlJxXIuWQbQ7fUO8T9H0xOwk30WGpbu{0%{width:48px;transform:scale(0)}50%{width:48px;transform:scale(1)}}.dot-toast-text,.dot-toast-buttons{animation:sQpiD3FtOHm94cL8vwSrE4Bn4LxtkAgH var(--toast-animate)}@keyframes sQpiD3FtOHm94cL8vwSrE4Bn4LxtkAgH{0%,50%{opacity:0}}.dot-toast._main{--toast-back: var(--m-88);--toast-react-back: var(--m-72);--toast-text: var(--m88)}.dot-toast._point{--toast-back: var(--p-88);--toast-react-back: var(--p-72);--toast-text: vaR(--p88)}.dot-toast._warn{--toast-back: var(--w-88);--toast-react-back: var(--w-72);--toast-text: vaR(--w88)}\n"]
    }]
  }], null, {
    operator: [{
      type: Input
    }],
    toast: [{
      type: Input
    }],
    closeText: [{
      type: Input
    }]
  });
})();
const LEVEL_COLOR_MAP = {
  low: null,
  high: 'main',
  medium: 'point',
  critical: 'warn'
};
class DotToastService {
  _store;
  _dock;
  _pool;
  _identifiedToasts = {};
  constructor(_store, _dock) {
    this._store = _store;
    this._dock = _dock;
    this._pool = _dock.add(_store.configure.position, DotToastPoolComponent, DotToastComponent);
  }
  confirmed(component) {
    const {
      id
    } = component.toast;
    const {
      _identifiedToasts
    } = this;
    if (_identifiedToasts[id]) {
      delete _identifiedToasts[id];
    }
  }
  // /**
  //  * @deprecated using `close`
  //  * @param ids
  //  */
  // confirm(...ids: string[]) {
  // 	this.close(...ids);
  // }
  close(...ids) {
    const {
      _identifiedToasts
    } = this;
    let current = ids.length;
    while (current-- > 0) {
      const id = ids[current];
      const componentRef = _identifiedToasts[id];
      if (componentRef) {
        componentRef.instance.confirm();
      }
    }
    return this;
  }
  open(rawOption) {
    const componentRef = this._pool.append({
      operator: this
    });
    promisify(rawOption).then(option => {
      promisify(option.body).then(body => {
        const {
          configure
        } = this._store;
        const {
          id,
          level
        } = option;
        if (!option.icon) {
          option.icon = configure.defaultIcons[level];
        }
        option.body = body;
        componentRef.setInput('toast', option);
        componentRef.setInput('display', true);
        componentRef.setInput('color', option.color);
        if (!id) {
          return;
        }
        const {
          _identifiedToasts
        } = this;
        const previousComponentRef = _identifiedToasts[id];
        if (previousComponentRef) {
          previousComponentRef.instance.confirm();
        }
        _identifiedToasts[id] = componentRef;
      });
    });
    return componentRef.instance;
  }
  low(option) {
    return this.open(setLevelAsAsync(option, 'low'));
  }
  /**
   * Toast with Main Palette
   * @param option
   */
  medium(option) {
    return this.open(setLevelAsAsync(option, 'medium'));
  }
  /**
   * Toast with Point Palette
   * @param option
   */
  high(option) {
    return this.open(setLevelAsAsync(option, 'high'));
  }
  /**
   * Toast with Warn Palette
   * @param option
   */
  critical(option) {
    return this.open(setLevelAsAsync(option, 'critical'));
  }
  /**
   * Get Toast Operator with Fixed ID
   *
   * @example
   * Before:
   * ```js
   * _toast.low({
   *     id: 'foo',
   *     body: 'First'
   * });
   *
   * _toast.low({
   *     id: 'foo',
   *     body: 'Second'
   * });
   *
   * _toast.low({
   *     id: 'foo',
   *     body: 'Third'
   * });
   * ```
   *
   * After:
   * ```js
   * const foo = _toast.series('foo');
   *
   * foo.low('First');
   * foo.low('Second');
   * foo.low('Third');
   * ```
   *
   * @param id will override to all of message
   */
  series(id) {
    return new DotToastSeries(this, id);
  }
  static ɵfac = function DotToastService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToastService)(i0.ɵɵinject(DotToastStoreService), i0.ɵɵinject(i2$1.DotDockService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotToastService,
    factory: DotToastService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToastService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: DotToastStoreService
  }, {
    type: i2$1.DotDockService
  }], null);
})();
/**
 * Toast Operator with Static ID
 */
class DotToastSeries {
  _operator;
  #id;
  constructor(_operator, id) {
    this._operator = _operator;
    this.#id = id;
  }
  confirmed(toast) {}
  close() {
    this._operator.close(this.#id);
    return this;
  }
  /**
   * @inheritDoc
   */
  low(option) {
    return this._operator.low(setIdAsAsync(option, this.#id));
  }
  /**
   * @inheritDoc
   */
  medium(option) {
    return this._operator.medium(setIdAsAsync(option, this.#id));
  }
  /**
   * @inheritDoc
   */
  high(option) {
    return this._operator.high(setIdAsAsync(option, this.#id));
  }
  /**
   * @inheritDoc
   */
  critical(option) {
    return this._operator.critical(setIdAsAsync(option, this.#id));
  }
}
function setLevelAsAsync(option, level) {
  return option instanceof Promise || option instanceof Observable ? promisify(option).then(option_ => setLevel(option_, level)) : setLevel(option, level);
}
function setIdAsAsync(option, id) {
  return option instanceof Promise || option instanceof Observable ? promisify(option).then(option_ => setId(option_, id)) : setId(option, id);
}
function setLevel(option, level) {
  if (typeof option === 'string') {
    return {
      body: option,
      level,
      color: LEVEL_COLOR_MAP[level]
    };
  }
  option.level = level;
  option.color = LEVEL_COLOR_MAP[level];
  return option;
}
function setId(option, id) {
  if (typeof option === 'string') {
    return {
      body: option,
      id
    };
  }
  option.id = id;
  return option;
}
class DotToastModule {
  static forRoot(configure = {}) {
    return {
      ngModule: DotToastModule,
      providers: [{
        provide: DOT_TOAST_CONFIGURE,
        useValue: configure,
        multi: false
      }]
    };
  }
  static ɵfac = function DotToastModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotToastModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotToastModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, DotTransDirective, DotFrameModule, DotCi24Module, DotIconModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotToastModule, [{
    type: NgModule,
    args: [{
      declarations: [DotToastPoolComponent, DotToastComponent],
      imports: [CommonModule, DotTransDirective, DotUpDirective, DotNonKrPipe, DotFrameModule, DotCi24Module, DotIconModule, DotUrlToAnchorPipe, DotObservifyPipe]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotToastModule, DotToastSeries, DotToastService, DotToastStoreService };
